import React, { useContext, useState } from 'react';

import { Context } from 'components/hoc/Store';
import LanguagePopoverWrapper from 'components/molecules/LanguageEditPopover';

import { strinTranslateParamsRegExp } from 'enums/regExp';

import getLanguageObject from 'utils/getLanguageObject';

interface ITranslateText {
    children: string;
    params?: (string | number)[];
    onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    displayPopoverParent?: boolean; // pouzite pri prekladoch (languagePopover)
    setSelectOpen?: React.Dispatch<React.SetStateAction<boolean>>; // pouzite pri prekladoch (languagePopover)
    languageEditID?: string;
    disableEdit?: boolean;
    id?: string;
}

const parserRules = [
    {
        pattern: /bold\((.*?)\)/g,
        replacement: '<b>$1</b>'
    },
    {
        pattern: /br\((.*?)\)/g,
        replacement: '<br/>'
    },
    {
        pattern: /italics\((.*?)\)/g,
        replacement: '<i>$1</i>'
    }
];

// Komponenta pouzita pro prekladani textu, sleduje v contextu language a podle jeji hodnoty vraci prislusny text
export const TranslateText: React.FC<ITranslateText> = ({
    children,
    params,
    onClick,
    displayPopoverParent,
    setSelectOpen,
    languageEditID,
    disableEdit,
    id
}) => {
    const { language, serviceMode, editaceTextu } = useContext(Context);
    const [displayPopover, setDisplayPopover] = useState<boolean>(false);
    const translatedText: string | Element =
        (editaceTextu && editaceTextu[language] && editaceTextu[language][children]) ||
        getLanguageObject(language)[children] ||
        getLanguageObject('cz')[children];

    /* premeni bold() a italic() z textov na HTML taggy */
    setTimeout(
        () =>
            document.querySelectorAll('.translateText').forEach(tag => {
                let inner = tag.innerHTML;

                parserRules.forEach(rule => {
                    inner = inner.replace(rule.pattern, rule.replacement);
                });
                tag.innerHTML = inner;
            }),
        0
    );

    // params nahradia vsetky {{xxx}} v stringu (podla indexu)
    if (params && children) {
        let strWithParams = getLanguageObject(language)[children];
        strWithParams &&
            params?.map(e => {
                const replaced = strWithParams.replace(
                    strinTranslateParamsRegExp,
                    getLanguageObject(language)[e] || String(e)
                );
                strWithParams = replaced;
            });

        return (
            <LanguagePopoverWrapper
                text={children}
                displayPopover={typeof displayPopoverParent === 'boolean' ? displayPopoverParent : displayPopover}
                onClick={onClick}
                setDisplayPopover={setDisplayPopover}
                setSelectOpen={setSelectOpen}
            >
                <span
                    id={id}
                    onClick={
                        // pouzite pri zmene prekladov languageEditPopover
                        serviceMode && !disableEdit // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            ? (e: any) => {
                                  // console.log(e.nativeEvent);
                                  const pathElements = e.nativeEvent.composedPath() as HTMLElement[];
                                  if (
                                      pathElements?.filter(
                                          u =>
                                              typeof u.className === 'string' &&
                                              (u.className || '').includes('translateText')
                                      ).length &&
                                      !pathElements?.filter(
                                          u =>
                                              typeof u.className === 'string' &&
                                              (u.className || '').includes('ant-select-show-arrow')
                                      ).length
                                  )
                                      setDisplayPopover(pv => !pv);
                              }
                            : () => {}
                    }
                    className="translateText"
                    style={
                        setSelectOpen
                            ? {
                                  width: '100%',
                                  display: 'inline-block'
                              }
                            : {}
                    }
                >
                    {strWithParams || children}
                </span>
            </LanguagePopoverWrapper>
        );
    }

    return (
        <LanguagePopoverWrapper
            text={languageEditID || children}
            displayPopover={typeof displayPopoverParent === 'boolean' ? displayPopoverParent : displayPopover}
            onClick={onClick}
            setDisplayPopover={setDisplayPopover}
            setSelectOpen={setSelectOpen}
        >
            <span
                id={id}
                onClick={
                    // pouzite pri zmene prekladov languageEditPopover
                    serviceMode && !disableEdit // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        ? (e: any) => {
                              const pathElements = e.nativeEvent.composedPath() as HTMLElement[];
                              if (
                                  pathElements?.filter(
                                      u =>
                                          typeof u.className === 'string' &&
                                          (u.className || '').includes('translateText')
                                  ).length &&
                                  !pathElements?.filter(
                                      u =>
                                          typeof u.className === 'string' &&
                                          (u.className || '').includes('ant-select-show-arrow')
                                  ).length
                              )
                                  setDisplayPopover(pv => !pv);
                          }
                        : () => {}
                }
                className="translateText"
                style={
                    setSelectOpen
                        ? {
                              width: '100%',
                              display: 'inline-block'
                          }
                        : {}
                }
            >
                {translatedText || children}
            </span>
        </LanguagePopoverWrapper>
    );
};

export default TranslateText;
